const config = {
  mainTitle: 'Banners',
  subHeading: 'A page to see banners',
  titleIcon: 'IosBookmarksOutline'
}

export default config
